/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Photo orientation
 */
export type PhotoOrientationEnum = 'FRONT' | 'BACK' | 'SELFIE' | 'OTHER';

export const PhotoOrientationEnum = {
    FRONT: 'FRONT' as PhotoOrientationEnum,
    BACK: 'BACK' as PhotoOrientationEnum,
    SELFIE: 'SELFIE' as PhotoOrientationEnum,
    OTHER: 'OTHER' as PhotoOrientationEnum
};